module.exports = __webpack_public_path__ + "img/pocket-10_en.fb57693.jpg";